export const FAVORECIDO_DETRO = 1
export const FAVORECIDO_APL = 2

export const FAVORECIDO_STRINGS = {
  [FAVORECIDO_DETRO]: 'DETRO',
  [FAVORECIDO_APL]: process.env.NOME_PRINCIPAL_EMPRESA
}



// WEBPACK FOOTER //
// ./src/domain/grv/helpers/pre-retirada-favorecidos.js